import React from "react";
import { useGetAllEcDevStats } from "@api/ecDevStatService";
import MaestroLoader from "@components/MaestroLoader";
import ErrorLoadingWidget from "./ErrorLoadingWidget";
import { LoadingWidget } from "./LoadingWidget";
import { Box, Button, CardCover, Grid, Typography } from "@mui/joy";
import StatWidgetCell, { StatSubtext, StatWidgetTitle, StatWithIcon } from "./StatWidgetCell";
import DataUsageRoundedIcon from '@mui/icons-material/DataUsageRounded';
import LocalAtmRoundedIcon from '@mui/icons-material/LocalAtmRounded';
import StoreRoundedIcon from '@mui/icons-material/StoreRounded';
import SquareFootRoundedIcon from '@mui/icons-material/SquareFootRounded';
import pluralize from 'pluralize';
import WidgetButtons from "./WidgetButtons";
import { formatCurrency } from "@utils/numbers";

export default function EcDevStatWidget(props) {
    const {
        // isPending,
        isLoading,
        isError,
        error,
        data,
        isFetching,
        isPreviousData,
    } = useGetAllEcDevStats();

    // pluralize

    if(isLoading) {
        return <LoadingWidget/>
    }

    if(isError) {
        return <ErrorLoadingWidget {...props} error={true} />
    }

    const simulateMouseUp = (fn) => {
        setTimeout(() => {
            fn();
        }, 200);
    }

    const editingSx = {
        '> *': {
            // transition: 'var(--mm-default-transition)',
        },
        ...(props.isEditing && {
            cursor: 'move',
            '> *': {
                filter: 'blur(2px)',
            },
        })
    };

    return (
        <Box container gap={2} display="grid" gridTemplateColumns={{xs: "repeat(3, 1fr)", md: "repeat(6, 1fr)", lg: "repeat(12, 1fr)"}} sx={{height: '100%'}}>
            <StatWidgetCell color="#F06D55" textColor="#fff" sx={editingSx}>
                <StatWidgetTitle>Occupancy Rate</StatWidgetTitle>
                <StatWithIcon
                    text={`${data.data.occupancy.rate}%`}
                    icon={<DataUsageRoundedIcon/>}
                />
                <StatSubtext>{Math.round(data.data.occupancy.occupied_units)} of {data.data.occupancy.units} {pluralize('unit', data.data.occupancy.units)} occupied</StatSubtext>
            </StatWidgetCell>

            <StatWidgetCell color="#91A578" textColor="#fff" sx={editingSx}>
                <StatWidgetTitle>Return on Investment</StatWidgetTitle>
                <StatWithIcon
                    text={`${data.data.roi.total}:1`}
                    icon={<LocalAtmRoundedIcon/>}
                />
                <StatSubtext>Private: {formatCurrency(Math.round(data.data.roi.private_investment))} | Public: {formatCurrency(Math.round(data.data.roi.public_investment))}</StatSubtext>
            </StatWidgetCell>

            <StatWidgetCell color="#e7b37c" textColor="#fff" sx={editingSx}>
                <StatWidgetTitle>Number of Businesses</StatWidgetTitle>
                <StatWithIcon
                    text={data.data.businesses.num}
                    icon={<StoreRoundedIcon/>}
                />
                <StatSubtext>Employees: {data.data.businesses.employees}</StatSubtext>
            </StatWidgetCell>

            <StatWidgetCell color="#B12C3B" textColor="#fff" sx={editingSx}>
                <StatWidgetTitle>Rent / Square Foot</StatWidgetTitle>
                <StatWithIcon
                    text={`\$${data.data['rent-square-foot'].rent}`}
                    icon={<SquareFootRoundedIcon/>}
                />
                <StatSubtext>{data.data['rent-square-foot'].units} {pluralize('unit', data.data['rent-square-foot'].units)}</StatSubtext>
            </StatWidgetCell>

            <Box
                sx={theme => ({
                    position: 'absolute',
                    zIndex: 100,
                    top: theme.spacing(1),
                    right: theme.spacing(1),
                    padding: 0,
                    backgroundColor: theme.palette.background.surface,
                    borderRadius: theme.radius.sm,
                    opacity: 0,
                    pointerEvents: 'none',
                    transition: 'var(--mm-default-transition)',
                })}

                style={
                    props.isEditing ? {
                        opacity: 1,
                        pointerEvents: 'all',
                    } : {}
                }
            >
                <WidgetButtons
                    widget={props.widget}
                    updateWidget={props.updateWidget}
                    isEditing={props.isEditing}
                    onEdit={props.onEdit}
                    onRemove={props.onRemove}
                    floating
                />
            </Box>
        </Box>
    );
}
